import moment from 'moment'

const DateFormatter=(date)=>{
   return moment(date).format('MMMM Do YYYY, h:mm:ss a')
}
export default DateFormatter;